import axios from 'axios';
import store from '@/data/store';

export const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
});

http.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) =>
    // error
    {
      // TODO: Untested functionality.
      //
      const request = error.config;

      if (error.response?.status === 401 && !request._retry) {
        await store.dispatch('logout');
      }

      return Promise.reject(error);
    }
);
